export default {
	title: 'Gear Library',
	selectAll: 'Select All',
	selectedCount: 'Selected {count} items',
	batchDelete: 'Batch Delete',
	batchDeleteWithCount: 'Batch Delete ({count})',
	noData: {
		title: 'No Gear Data',
		description: 'No gear data found'
	},
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Delete successful',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty'
	},
	form: {
		name: 'Gear Name',
		type: 'Gear Type',
		module: 'Module',
		teethNumber: 'Teeth Number',
		pressureAngle: 'Pressure Angle',
		material: 'Material',
		placeholder: {
			name: 'Please enter gear name',
			type: 'Please enter gear type',
			module: 'Please enter module',
			teethNumber: 'Please enter teeth number',
			pressureAngle: 'Please enter pressure angle',
			material: 'Please enter material'
		}
	},
	table: {
		name: 'Gear Name',
		type: 'Gear Type',
		module: 'Module',
		teethNumber: 'Teeth Number',
		pressureAngle: 'Pressure Angle',
		material: 'Material'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm'
	}
}
